// Modal.js
import { motion } from "framer-motion";
import Backdrop from "../Backdrop/backdrop";
import styles from "./modal.module.css";

const dropIn = {
  hidden: {
    y: "-150vh",
    opacity: 0,
  },
  visible: {
    y: "0",
    opacity: 1,
    transition: {
      duration: 0.1,
      type: "spring",
      damping: 25,
      stiffness: 500,
    },
  },
  exit: {
    y: "150vh", // Increase the end position
    opacity: 0,
    transition: {
      duration: 0.5, // Increase the duration for exit as well
      ease: "easeInOut",
    },
  },
};

const Modal = ({ handleClose, id, title, text }) => {
  return (
    <Backdrop onClick={handleClose}>
      <motion.div
        onClick={(e) => e.stopPropagation()}
        className={styles.modal}
        variants={dropIn}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        <h2>{title}</h2>
        <p>{text}</p>
        <motion.button
          className={styles.modalButton}
          onClick={handleClose}
          whileHover={{ scale: 1.1 }} // Bounce effect on hover
          whileTap={{ scale: 0.9 }} // Bounce effect on click
        >
          Close
        </motion.button>
      </motion.div>
    </Backdrop>
  );
};

export default Modal;
